import { combineReducers } from "redux";
import uiReducer from "./uiReducer";

const sideBar = (state = {}, action) => {
  switch (action.type) {
    case "SIDEBAR_OPEN":
      return {
        ...state,
        sidebarOpen: action.data,
      };
    default:
      return {
        ...state,
        sidebarOpen: false,
      };
  }
};

const rootReducer = combineReducers({
  uiReducer,
  sideBar,
});

export default rootReducer;
